import type { Icon, TablerIconsProps } from '@tabler/icons-react';
import { IconBrandMastercard, IconBrandVisa, IconCreditCard } from '@tabler/icons-react';
import { Box, Flex, createStyles } from '@mantine/core';

import { CardType } from '~/services/wallet/interfaces/wallets.interface';

export function IconVisa({ size = 24 }: { size?: number }) {
  const height = size;
  const width = size * 1.54667;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.25" y="0.5" width="35" height="23" rx="3.5" stroke="#D1D1D1" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8753 16.2582H10.7549L9.16495 10.1924C9.08949 9.91334 8.92925 9.66667 8.69354 9.5504C8.10531 9.25823 7.45712 9.0257 6.75 8.90843V8.6749H10.1657C10.6371 8.6749 10.9906 9.0257 11.0496 9.43313L11.8745 13.8086L13.9938 8.6749H16.0552L12.8753 16.2582ZM17.2338 16.2582H15.2313L16.8802 8.6749H18.8827L17.2338 16.2582ZM21.4734 10.7757C21.5323 10.3673 21.8859 10.1337 22.2983 10.1337C22.9465 10.0751 23.6526 10.1924 24.2419 10.4835L24.5954 8.85081C24.0062 8.61727 23.358 8.5 22.7698 8.5C20.8262 8.5 19.412 9.55041 19.412 11.0082C19.412 12.1173 20.4137 12.6996 21.1208 13.0504C21.8859 13.4002 22.1805 13.6338 22.1216 13.9835C22.1216 14.5082 21.5323 14.7418 20.9441 14.7418C20.2369 14.7418 19.5298 14.5669 18.8827 14.2747L18.5291 15.9085C19.2362 16.1996 20.0012 16.3169 20.7084 16.3169C22.8876 16.3745 24.2419 15.3251 24.2419 13.75C24.2419 11.7665 21.4734 11.6502 21.4734 10.7757ZM31.25 16.2582L29.66 8.6749H27.9522C27.5986 8.6749 27.2451 8.90843 27.1272 9.25823L24.1829 16.2582H26.2443L26.6558 15.1502H29.1886L29.4243 16.2582H31.25ZM28.2467 10.7168L28.8349 13.5748H27.186L28.2467 10.7168Z"
        fill="#172B85"
      />
    </svg>
  );
}

export function IconMasterCard({ size = 24 }: { size?: number }) {
  const height = size;
  const width = size * 1.5;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.25" y="0.5" width="35" height="23" rx="3.5" stroke="#D1D1D1" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.75 17.1569C17.5584 18.1852 16.0128 18.806 14.3238 18.806C10.5551 18.806 7.5 15.7154 7.5 11.903C7.5 8.09057 10.5551 5 14.3238 5C16.0128 5 17.5584 5.62075 18.75 6.64903C19.9416 5.62075 21.4872 5 23.1762 5C26.9449 5 30 8.09057 30 11.903C30 15.7154 26.9449 18.806 23.1762 18.806C21.4872 18.806 19.9416 18.1852 18.75 17.1569Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.75 17.1569C20.2172 15.8908 21.1475 14.0068 21.1475 11.903C21.1475 9.79917 20.2172 7.91517 18.75 6.64903C19.9416 5.62075 21.4872 5 23.1762 5C26.9449 5 30 8.09057 30 11.903C30 15.7154 26.9449 18.806 23.1762 18.806C21.4872 18.806 19.9416 18.1852 18.75 17.1569Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.75 17.1569C20.2172 15.8908 21.1475 14.0068 21.1475 11.903C21.1475 9.79917 20.2172 7.91518 18.75 6.64905C17.2829 7.91518 16.3525 9.79917 16.3525 11.903C16.3525 14.0068 17.2829 15.8908 18.75 17.1569Z"
        fill="#FF5E00"
      />
    </svg>
  );
}

export function IconDiscover({ size = 24 }: { size?: number }) {
  const height = size;
  const width = size * (37 / 24);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.25" y="0.5" width="35" height="23" rx="3.5" stroke="#D1D1D1" />
      <svg x="4" y="3" width="31" height="18" viewBox="55 192 680 116">
        <path
          d="m409.41 197.26c30.938 0 56.02 23.58 56.02 52.709v0.033c0 29.129-25.082 52.742-56.02 52.742-30.941 0-56.022-23.613-56.022-52.742v-0.033c0-29.129 25.081-52.709 56.022-52.709z"
          fill="#F47216"
        />
        <path
          d="m321.43 197.94c8.836 0 16.247 1.785 25.27 6.09v22.753c-8.544-7.863-15.955-11.154-25.757-11.154-19.265 0-34.413 15.015-34.413 34.051 0 20.074 14.681 34.195 35.368 34.195 9.312 0 16.586-3.12 24.802-10.856v22.764c-9.343 4.142-16.912 5.775-25.757 5.775-31.277 0-55.581-22.597-55.581-51.736-2e-3-28.83 24.949-51.882 56.068-51.882zm-97.113 0.626c11.546 0 22.109 3.721 30.942 10.994l-10.748 13.248c-5.351-5.646-10.411-8.027-16.563-8.027-8.854 0-15.301 4.744-15.301 10.988 0 5.354 3.618 8.188 15.944 12.481 23.364 8.043 30.289 15.176 30.289 30.926 0 19.193-14.976 32.554-36.319 32.554-15.631 0-26.993-5.795-36.457-18.871l13.268-12.03c4.73 8.608 12.622 13.223 22.42 13.223 9.163 0 15.947-5.95 15.947-13.983 0-4.164-2.056-7.733-6.158-10.258-2.066-1.195-6.158-2.978-14.199-5.646-19.292-6.538-25.91-13.527-25.91-27.186-1e-3-16.227 14.213-28.413 32.845-28.413zm234.72 1.729h22.436l28.084 66.592 28.447-66.592h22.267l-45.493 101.69h-11.054l-44.687-101.69zm-301.21 0.152h20.541v99.143h-20.541v-99.143zm411.73 0h58.253v16.799h-37.726v22.006h36.336v16.791h-36.336v26.762h37.726v16.785h-58.253v-99.143zm115.59 57.377c15.471-2.965 23.983-12.926 23.983-28.105 0-18.562-13.575-29.271-37.266-29.271h-30.454v99.144h20.516v-39.83h2.681l28.43 39.828h25.26l-33.15-41.766zm-17.218-11.736h-6.002v-30.025h6.326c12.791 0 19.744 5.049 19.744 14.697 2e-3 9.967-6.951 15.328-20.068 15.328zm-576.09-45.641h-30.149v99.143h29.992c15.946 0 27.465-3.543 37.573-11.445 12.014-9.359 19.117-23.467 19.117-38.057 1e-3-29.259-23.221-49.641-56.533-49.641zm23.997 74.479c-6.454 5.484-14.837 7.879-28.108 7.879h-5.514v-65.559h5.513c13.271 0 21.323 2.238 28.108 8.018 7.104 5.956 11.377 15.184 11.377 24.682 1e-3 9.513-4.273 19.024-11.376 24.98z"
          fill="#231F20"
        />
      </svg>
    </svg>
  );
}

const cartTypeToIconComponent: Record<CardType, Icon> = {
  [CardType.MC]: IconBrandMastercard,
  [CardType.VI]: IconBrandVisa,
  [CardType.AM]: IconBrandMastercard,
  [CardType.DI]: IconDiscover,
};

export default function CardTypeIcon({ type, ...props }: TablerIconsProps & { type?: CardType }) {
  const Icon = cartTypeToIconComponent[type] ?? IconCreditCard;
  return <Icon {...props} />;
}

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    gap: theme.other.spacing._8,
    maxWidth: 130,
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
  },
}));

export function CardTypeIconMultiple() {
  const { classes } = useStyles();
  return (
    <Flex className={classes.container}>
      <Box className={classes.iconBox}>
        <IconVisa />
      </Box>
      <Box className={classes.iconBox}>
        <IconMasterCard />
      </Box>
      <Box className={classes.iconBox}>
        <IconDiscover />
      </Box>
    </Flex>
  );
}
